import { render, staticRenderFns } from "./EducationalStageAdd.vue?vue&type=template&id=581a6e40&"
import script from "./EducationalStageAdd.vue?vue&type=script&lang=js&"
export * from "./EducationalStageAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports